// Layout params
import { get } from 'lodash';
import { LAYOUT_CARD_LARGE, LAYOUT_CARD_MEDIUM, LAYOUT_CARD_SMALL, LAYOUT_FULL_POST, LAYOUT_GRID, LAYOUT_LIST, LAYOUT_LIST_LARGE, LAYOUT_LIST_MEDIUM, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_GRID, LAYOUT_PG_GRID_INTERMEDIATE, LAYOUT_PG_GRID_LARGE, LAYOUT_PG_ONE_COLUMN, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_SIDE_BY_SIDE_RIGHT, LAYOUT_PG_TEXT_ON_IMAGE_LARGE, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_TEXT_ON_IMAGE_SMALL, LAYOUT_SIDE_BY_SIDE, LAYOUT_SIDE_BY_SIDE_MOBILE, LAYOUT_SLIDER, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_TEXT_ON_IMAGE_SMALL, } from '../layout-types';
import { SECTION_MY_POSTS } from '../sections';
export const IS_MOBILE_LAYOUT_SETTINGS_ENABLED = 'blog-mobile-isMobileLayoutSettingsEnabled';
export const IS_MOBILE_LAYOUT_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_LAYOUT_SETTINGS_ENABLED}`;
export const IS_POST_DESIGN_IN_FULL_POST_ENABLED = 'blog-postDesignInFullpostEnabled';
export const IS_POST_DESIGN_IN_FULL_POST_ENABLED_PATH = `style.booleans.${IS_POST_DESIGN_IN_FULL_POST_ENABLED}`;
const getLayoutParam = (section, param, isMobile) => `layout-${isMobile ? 'mobile-' : ''}${section}-${param}`;
export const getLayoutType = (section, isMobile = false) => getLayoutParam(section, 'layoutType', isMobile);
export const getLayoutTypePath = (section, isMobile = false) => `style.numbers.${getLayoutType(section, isMobile)}`;
function getPGLayoutParam(param) {
    function getter(section, layoutName, isMobile = false) {
        return `layout-${isMobile ? 'mobile-' : ''}${section}-${layoutName}-${param}`;
    }
    return getter;
}
const getPGLayoutParamPath = (getLayoutParamFn) => (section, layoutName, isMobile = false) => `style.numbers.${getLayoutParamFn(section, layoutName, isMobile)}`;
export const getLayoutSpacingParam = getPGLayoutParam('layoutSpacing');
export const getLayoutPostSizeParam = getPGLayoutParam('layoutPostSize');
export const getLayoutCardsRowTypeParam = getPGLayoutParam('layoutCardsRowType');
export const getLayoutPostsPerRowParam = getPGLayoutParam('layoutPostsPerRow');
export const getLayoutContentHeightParam = getPGLayoutParam('contentHeight');
export const getLayoutContentHeightTypeParam = getPGLayoutParam('contentHeightType');
export const getLayoutMarginsParam = getPGLayoutParam('margins');
export const getLayoutTitleLineCountParam = getPGLayoutParam('titleLineCount');
export const getLayoutDescriptionLineCountParam = getPGLayoutParam('descriptionLineCount');
export const getLayoutSidesPaddingParam = getPGLayoutParam('sidesPadding');
export const getLayoutImageRatioParam = getPGLayoutParam('imageRatio');
export const getLayoutImageAlignmentParam = getPGLayoutParam('imageAlignment');
export const getLayoutImageProportionsParam = getPGLayoutParam('imageProportions');
export const getLayoutImageCropTypeParam = getPGLayoutParam('imageCropType');
export const getLayoutImageResizingModeParam = getPGLayoutParam('imageResizingMode');
export const getLayoutImageWidthParam = getPGLayoutParam('imageWidth');
export const getLayoutSpacingParamPath = getPGLayoutParamPath(getLayoutSpacingParam);
export const getLayoutPostSizeParamPath = getPGLayoutParamPath(getLayoutPostSizeParam);
export const getLayoutCardsRowTypeParamPath = getPGLayoutParamPath(getLayoutCardsRowTypeParam);
export const getLayoutPostsPerRowParamPath = getPGLayoutParamPath(getLayoutPostsPerRowParam);
export const getLayoutImageRatioParamPath = getPGLayoutParamPath(getLayoutImageRatioParam);
export const getLayoutContentHeightParamPath = getPGLayoutParamPath(getLayoutContentHeightParam);
export const getLayoutContentHeightTypeParamPath = getPGLayoutParamPath(getLayoutContentHeightTypeParam);
export const getLayoutMarginsParamPath = getPGLayoutParamPath(getLayoutMarginsParam);
export const getLayoutTitleLineCountParamPath = getPGLayoutParamPath(getLayoutTitleLineCountParam);
export const getLayoutDescriptionLineCountParamPath = getPGLayoutParamPath(getLayoutDescriptionLineCountParam);
export const getLayoutSidesPaddingParamPath = getPGLayoutParamPath(getLayoutSidesPaddingParam);
export const getLayoutImageAlignmentParamPath = getPGLayoutParamPath(getLayoutImageAlignmentParam);
export const getLayoutImageProportionsParamPath = getPGLayoutParamPath(getLayoutImageProportionsParam);
export const getLayoutImageCropTypeParamPath = getPGLayoutParamPath(getLayoutImageCropTypeParam);
export const getLayoutImageResizingModeParamPath = getPGLayoutParamPath(getLayoutImageResizingModeParam);
export const getLayoutImageWidthParamPath = getPGLayoutParamPath(getLayoutImageWidthParam);
const getPaginationParam = (section, param) => `pagination-${section}-${param}`;
export const getPaginationPageSize = (section) => getPaginationParam(section, 'pageSize');
export const getPaginationPageSizePath = (section) => `style.numbers.${getPaginationPageSize(section)}`;
export const getPaginationType = (section) => getPaginationParam(section, 'type');
export const getPaginationTypePath = (section) => `style.numbers.${getPaginationType(section)}`;
const getRatingFontDefaultProps = (isToiLayout = false) => ({
    startWithColor: isToiLayout ? '#FFFFFF' : 'color-5',
    startWithTheme: 'font_8',
    fontMinSize: 12,
    fontMaxSize: 24,
    startWithSize: 14,
});
export const LAYOUT_SETTINGS_PROPS = {
    [LAYOUT_CARD_MEDIUM]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 26,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SIDE_BY_SIDE]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_MEDIUM]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 26,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_GRID]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 22,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_CARD_SMALL]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 22,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_SMALL]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            startWithColor: '#FFFFFF',
            startWithSize: 16,
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_CARD_LARGE]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 16,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_FULL_POST]: {
        titleFont: {
            fontMinSize: 28,
            fontMaxSize: 176,
            startWithSize: 40,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            startWithColor: 'color-5',
            fontMinSize: 14,
            fontMaxSize: 176,
            startWithSize: 18,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_ONE_COLUMN_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 22,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 14,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SIDE_BY_SIDE_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 14,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 14,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_TEXT_ON_IMAGE_MOBILE]: {
        titleFont: {
            fontMinSize: 12,
            fontMaxSize: 30,
            startWithSize: 22,
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 18,
            startWithSize: 16,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_SMALL]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 26,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_TEXT_ON_IMAGE_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: '#FFFFFF',
        },
        descriptionFont: {
            hideSize: true,
            startWithSize: 16,
            startWithColor: '#FFFFFF',
        },
        ratingFont: getRatingFontDefaultProps(true),
    },
    [LAYOUT_PG_CARD_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 26,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_SIDE_BY_SIDE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_SIDE_BY_SIDE_RIGHT]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID_INTERMEDIATE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_GRID_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_PG_ONE_COLUMN]: {
        titleFont: {
            fontMinSize: 16,
            fontMaxSize: 176,
            startWithSize: 28,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 12,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST_MEDIUM]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 18,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_LIST_LARGE]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 14,
            startWithColor: 'color-5',
            hideSize: true,
        },
        ratingFont: getRatingFontDefaultProps(),
    },
    [LAYOUT_SLIDER]: {
        titleFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
};
const LAYOUT_SETTINGS_PROPS_MY_POSTS = {
    [LAYOUT_PG_SIDE_BY_SIDE]: {
        titleFont: {
            hideTheme: false,
            fontMinSize: 16,
            fontMaxSize: 28,
            startWithSize: 22,
            startWithColor: 'color-5',
        },
        descriptionFont: {
            hideSize: true,
            hideTheme: false,
            fontMinSize: 6,
            fontMaxSize: 176,
            startWithSize: 16,
            startWithColor: 'color-5',
        },
        ratingFont: getRatingFontDefaultProps(),
    },
};
export const getLayoutSettingsProps = (layoutType, section) => {
    const settingsByLayoutType = section === SECTION_MY_POSTS ? LAYOUT_SETTINGS_PROPS_MY_POSTS : LAYOUT_SETTINGS_PROPS;
    return settingsByLayoutType[layoutType];
};
export const getLayoutDefaultFontSize = (layoutType, section, contentType) => {
    const layoutSettingsProps = getLayoutSettingsProps(layoutType, section);
    return get(layoutSettingsProps, `${contentType}.startWithSize`);
};
export const LAYOUT_DEFAULT_FONT_FAMILY = 'open sans';
export const LAYOUT_DEFAULT_CSS_FONT_FAMILY = '"open sans", sans-serif';
export const LAYOUT_DEFAULT_FONT = {
    displayName: 'Paragraph 2',
    editorKey: 'font_2',
    family: LAYOUT_DEFAULT_FONT_FAMILY,
    fontStyleParam: true,
    preset: 'Custom',
    size: 15,
    style: {
        bold: false,
        italic: false,
        underline: false,
    },
    value: `font:normal normal normal 15px/21px ${LAYOUT_DEFAULT_CSS_FONT_FAMILY}`,
};
export const getSBSLayoutImagePositionParam = (section) => `blog-sideBySideLayoutImagePosition-${section}`;
export const getSBSLayoutImagePositionParamPath = (section) => `style.numbers.${getSBSLayoutImagePositionParam(section)}`;
//# sourceMappingURL=layout.wix-params.js.map